import { FC, PropsWithChildren, useEffect, useState } from 'react';
import ReportHubDownload from './components/ReportHub/ReportHubModals/GenerateReport/ReportHubDownload';
import { useAppSelector } from './redux/hooks';
import { selectedReportHubQuerysInProgress } from './redux/reducers/reportHubQuerysInProgress';
import CustomErrorBoundary from './components/LayoutWrapper/CustomErrorBoundary';
import { ErrorBoundaryUI } from './components/ErrorBoundary/ErrorBoundaryUI';

const PersistingQuerysWrapper: FC<PropsWithChildren> = ({ children }) => {
  const reportHubQuerysInProgressRedux = useAppSelector(selectedReportHubQuerysInProgress);

  const [isQueryRunning, setIsQueryRunning] = useState<boolean>(false);

  useEffect(() => {
    if (reportHubQuerysInProgressRedux) setIsQueryRunning(true);
    else setIsQueryRunning(false);
  }, [reportHubQuerysInProgressRedux]);

  return isQueryRunning ? (
    <CustomErrorBoundary fallback={<ErrorBoundaryUI />}>
      {children}
      <ReportHubDownload />
    </CustomErrorBoundary>
  ) : (
    children
  );
};

export default PersistingQuerysWrapper;
